import { useConsent } from "@/context/ConsentContext";
import {
  ensureHubspotLoader,
  revokeHubspotConsent,
} from "@/utils/hubspotLoader";
import { useEffect, useRef } from "react";

export function HubSpotLoader() {
  const { hydrated, marketing } = useConsent();
  const loadedForMarketing = useRef(false);

  useEffect(() => {
    if (!hydrated) return;
    if (marketing) {
      ensureHubspotLoader();
      loadedForMarketing.current = true;
    } else if (loadedForMarketing.current) {
      // Marketing was granted (HubSpot's always-on tracking loaded) and is now
      // withdrawn — revoke so it stops setting tracking cookies. The on-demand
      // support-chat load is functional, not marketing, so it isn't revoked here.
      revokeHubspotConsent();
    }
  }, [hydrated, marketing]);

  return null;
}
